import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {InvestorRoutingModule} from './investor-route.module';
import { ProfileComponent } from './profile/profile.component';
import { ThingstodoComponent } from './thingstodo/thingstodo.component';
import { TaxformsComponent } from './taxforms/taxforms.component';
import { TaxformNonResidentialComponent } from './taxform-non-residential/taxform-non-residential.component';
import {FormsModule} from '@angular/forms';

//import { DataprivacyComponent } from './dataprivacy/dataprivacy.component';
import { FaqComponent } from './faq/faq.component';
import { TermsAndConditionComponent } from './terms-and-condition/terms-and-condition.component';
import { DownloadfileComponent } from './downloadfile/downloadfile.component';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatIconModule} from '@angular/material/icon'
import {MatRadioModule} from '@angular/material/radio';
import {
  MatFormFieldModule
} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    InvestorRoutingModule,
    FormsModule,
    MatDatepickerModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    ProfileComponent,
    ThingstodoComponent,
    TaxformsComponent,
    TaxformNonResidentialComponent,
    FaqComponent,
    TermsAndConditionComponent,
    DownloadfileComponent
    ],
  exports:[],
  
})
export class InvestorModule { }
